export enum RoutePointState {
  DEFAULT,
  DETAILS,
  FORM,
  STATUS,
}
